<template>
  <div class="flex flex-wrap items-start gap-8">
    <SupportFields class="flex-[1_1_18.75rem]">
      <ResourcesFields />
    </SupportFields>
    <LegalFields class="flex-[1_1_18.75rem]">
      <p class="rounded-md bg-muted p-3 text-xs leading-relaxed text-muted-foreground">
        {{ t('admin.setup.contact.legal.later') }}
      </p>
    </LegalFields>
  </div>
</template>

<script setup lang="ts">
import LegalFields from '@/features/admin/platform-setup/components/steps/legal-fields.vue'
import ResourcesFields from '@/features/admin/platform-setup/components/steps/resources-fields.vue'
import SupportFields from '@/features/admin/platform-setup/components/steps/support-fields.vue'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
</script>
